import { render, staticRenderFns } from "./LoadAnimation2.vue?vue&type=template&id=bdeb146c&scoped=true&"
import script from "./LoadAnimation2.vue?vue&type=script&lang=js&"
export * from "./LoadAnimation2.vue?vue&type=script&lang=js&"
import style0 from "./LoadAnimation2.vue?vue&type=style&index=0&id=bdeb146c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdeb146c",
  null
  
)

export default component.exports